import { render, staticRenderFns } from "./ImageStack.vue?vue&type=template&id=0cb31252&scoped=true"
import script from "./ImageStack.vue?vue&type=script&lang=js"
export * from "./ImageStack.vue?vue&type=script&lang=js"
import style0 from "./ImageStack.vue?vue&type=style&index=0&id=0cb31252&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb31252",
  null
  
)

export default component.exports